import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { AuthSkeleton } from '../auth/ProtectedRoute.js';
import { finishGoogleSignIn, parseGoogleCallback } from '../auth/googleSignIn.js';

/**
 * /auth/google — Google comes back here with an ID token in the URL
 * fragment (see auth/googleSignIn.ts). Hands it to Supabase, then goes home
 * (new accounts continue to /onboarding from there) or back to the screen
 * the Google button was on.
 */
export function GoogleCallback() {
  const navigate = useNavigate();
  const started = useRef(false);

  useEffect(() => {
    // StrictMode runs effects twice in dev; a Google token signs in once.
    if (started.current) return;
    started.current = true;
    const result = parseGoogleCallback(window.location.hash);
    // The token must not stay in the address bar or the history.
    window.history.replaceState(null, '', window.location.pathname);
    void finishGoogleSignIn(result).then((to) => navigate(to, { replace: true }));
  }, [navigate]);

  return <AuthSkeleton />;
}
